import React, {useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components'
import ContactComponent from '../components/contactComponent';


interface Prop{
}
const Support : React.FC<Prop>=({})=>{
  return(
    <MainContainer>
        <Column>
          <ContactComponent />
        </Column>
    </MainContainer>
  );
}


const MainContainer = styled.div`
    // display: flex;
    flex-direction: column;
    min-height: 85vh;
    justify-content: flex-start;
    align-items: center;
`
const Column = styled.div`

`;

export default Support